module.exports = __webpack_public_path__ + "assets/img/4f05-xx.svg";